export class ConfirmDialogOptions {
    dialogId: string;
    hideCancelButton: boolean;
    showCloseButton: boolean;
    titleText: string;
    contentText: string;
    cancelText: string;
    confirmText: string;
    closeButtonId: string;
    cancelButtonId: string;
    confirmButtonId: string;
    cancelAriaLabel: string;
    confirmAriaLabel: string;
    hideAppStoreButtons: boolean;
    appStoreUrl: string;
    playStoreUrl: string;

    constructor(options: Partial<ConfirmDialogOptions> = {}) {
        this.dialogId = options.dialogId || '';
        this.hideCancelButton = options.hideCancelButton || false;
        this.showCloseButton = options.showCloseButton || false;
        this.titleText = options.titleText || '';
        this.contentText = options.contentText || '';
        this.cancelText = options.cancelText || $localize`Cancel`;
        this.confirmText = options.confirmText || $localize`OK`;
        this.closeButtonId = options.closeButtonId || 'close';
        this.cancelButtonId = options.cancelButtonId || 'cancel';
        this.confirmButtonId = options.confirmButtonId || 'confirm';
        this.cancelAriaLabel = options.cancelAriaLabel || 'cancel';
        this.confirmAriaLabel = options.confirmAriaLabel || 'confirm';
        this.hideAppStoreButtons = options.hideAppStoreButtons || true;
        this.appStoreUrl = options.appStoreUrl || '';
        this.playStoreUrl = options.playStoreUrl || '';
    }
}
